import { Directive, HostListener, inject } from '@angular/core';
import { MockTestSecurityService } from './mock-test-security.service';

/**
 * Element-level defense-in-depth for question/option/explanation containers:
 * disables selection and blocks copy/cut/context-menu/drag on this element
 * specifically, independent of the document-level listeners the security
 * service attaches while active. Does not touch pointer events, so buttons
 * and inputs inside the element keep working normally.
 */
@Directive({
  selector: '[appMockTestSecureContent]',
  host: {
    style: 'user-select: none; -webkit-user-select: none;',
  },
})
export class MockTestSecureContentDirective {
  private readonly securityService = inject(MockTestSecurityService);

  @HostListener('contextmenu', ['$event'])
  protected onContextMenu(event: Event): void {
    event.preventDefault();
    // Proctoring disabled for now — no violation reporting/warning toast.
    // this.securityService.reportViolation(SecurityViolationType.CONTEXT_MENU);
  }

  @HostListener('copy', ['$event'])
  protected onCopy(event: Event): void {
    event.preventDefault();
    // Proctoring disabled for now — no violation reporting/warning toast.
    // this.securityService.reportViolation(SecurityViolationType.COPY_ATTEMPT);
  }

  @HostListener('dragstart', ['$event'])
  protected onDragStart(event: Event): void {
    event.preventDefault();
    // Proctoring disabled for now — no violation reporting/warning toast.
    // this.securityService.reportViolation(SecurityViolationType.DRAG_ATTEMPT);
  }

  @HostListener('selectstart', ['$event'])
  protected onSelectStart(event: Event): void {
    event.preventDefault();
  }
}
